import { useMemo } from 'react';

import { HiddenFilter } from 'framework-listing-lib/types';
import {
  useCrmObjectType,
  useComputedFilters,
  useFiltersStateStore,
} from '../internal/providers/CrmObjectTypeListingClientProvider';
import useQuickFilters from './useQuickFilters';

export const useFilterGroups = () => {
  'use memo';
  return useComputedFilters().filterGroups;
};
export const useFilterQuery = () => {
  'use memo';
  return useFiltersStateStore((state) => state.filtersState.query);
};
export const useSortState = () => {
  'use memo';
  return useFiltersStateStore((state) => state.filtersState.sort);
};
export const useFiltersState = () => {
  'use memo';
  const filterGroups = useFilterGroups();
  const quickFilters = useQuickFilters();
  const filterState = useFiltersStateStore((state) => state.filtersState);
  return useMemo(
    () => ({
      ...filterState,
      filterGroups,
      quickFilters,
    }),
    [filterGroups, filterState, quickFilters]
  );
};
export const useDeletedObjects = () => {
  'use memo';
  return useFiltersStateStore((state) => state.deletedObjects);
};

export function useHiddenFilter(): HiddenFilter {
  'use memo';
  const { hiddenFilter } = useCrmObjectType();

  return useMemo(
    () =>
      hiddenFilter || {
        filterGroups: [
          {
            filters: [],
          },
        ],
      },
    [hiddenFilter]
  );
}

export const useInitialFilter = () => {
  'use memo';
  const { initialFilter } = useCrmObjectType();
  return initialFilter;
};

export const useIsFilterFromCustomView = () => {
  'use memo';
  const { isFilterFromCustomView } = useCrmObjectType();
  return isFilterFromCustomView;
};
